/* eslint-disable no-console */
import {FormInstance} from 'antd';

import {
  CA_DOCUMENT_TYPE_VALUES,
  CADocumentTypeValue
} from '../../../pages/aiDocumentManager/Constants/commonConstants';
import businessTravelAPI from '../../../services/modules/IP/businessTravelAPI';
import capitalGoodsAPI from '../../../services/modules/IP/capitalGoodAPI';
import electricityAPI from '../../../services/modules/IP/electricityAPI';
import fugitiveAPI from '../../../services/modules/IP/fugitiveAPI';
import machineDetails from '../../../services/modules/IP/machineAPI';
import supplyChainAPI from '../../../services/modules/IP/supplyChainAPI';
import vehicleAPI from '../../../services/modules/IP/vehicleAPI';
import waterAPI from '../../../services/modules/IP/waterAPI';
import rawMaterialAPI from '../../../services/modules/PRODUCTS/rawMaterialAPI';

export interface IType {
  key: string;
  value: string;
}

export interface IComponentProps {
  caForm: FormInstance;
  record?: any;
  onFinishFailed: () => void;
  onValuesChange: (value: boolean) => void;
  onSubmit: () => void;
}

export interface IPreConfig {
  mainAPI: any;
  billType: string;
  componentName: string;
  type: IType | null;
}
const getPrerequisiteMasterData = (record: any): IPreConfig => {
  const key: CADocumentTypeValue | undefined =
    record?.method ?? record?.bill_type ?? record?.doc_type;

  switch (key) {
    // Fuel Bill
    case CA_DOCUMENT_TYPE_VALUES.FOR_MACHINES:
      return {
        mainAPI: machineDetails,
        billType: key,
        componentName: key,
        type: null
      };

    case CA_DOCUMENT_TYPE_VALUES.FOR_VEHICLE:
      return {
        mainAPI: vehicleAPI,
        billType: key,
        componentName: key,
        type: null
      };

    case CA_DOCUMENT_TYPE_VALUES.FOR_REFRIGERANT:
      return {
        mainAPI: fugitiveAPI,
        billType: key,
        componentName: key,
        type: null
      };

    // Electricity Bills
    case CA_DOCUMENT_TYPE_VALUES.RENEWABLE:
      return {
        mainAPI: electricityAPI,
        billType: key,
        componentName: key,
        type: {key: 'renewableType', value: 'Renewable'}
      };

    case CA_DOCUMENT_TYPE_VALUES.NON_RENEWABLE:
      return {
        mainAPI: electricityAPI,
        billType: key,
        componentName: key,
        type: {key: 'renewableType', value: 'Non-renewable'}
      };

    case CA_DOCUMENT_TYPE_VALUES.RAW_MATERIAL_AVERAGE:
      return {
        mainAPI: rawMaterialAPI,
        billType: key,
        componentName: key,
        type: {key: 'method', value: 'Average'}
      };

    case CA_DOCUMENT_TYPE_VALUES.RAW_MATERIAL_SUPPLIER_SPECIFIC:
      return {
        mainAPI: rawMaterialAPI,
        billType: key,
        componentName: key,
        type: {key: 'method', value: 'Supplier'}
      };

    case CA_DOCUMENT_TYPE_VALUES.CAPITAL_GOOD_AVERAGE:
      return {
        mainAPI: capitalGoodsAPI,
        billType: key,
        componentName: key,
        type: {key: 'method', value: 'Average'}
      };

    case CA_DOCUMENT_TYPE_VALUES.CAPITAL_GOOD_SUPPLIER_SPECIFIC:
      return {
        mainAPI: capitalGoodsAPI,
        billType: key,
        componentName: key,
        type: {key: 'method', value: 'Supplier specific'}
      };

    case CA_DOCUMENT_TYPE_VALUES.UPSTREAM_TRANSPORT:
      return {
        mainAPI: supplyChainAPI,
        billType: key,
        componentName: key,
        type: null
      };

    case CA_DOCUMENT_TYPE_VALUES.DOWNSTREAM_TRANSPORT:
      return {
        mainAPI: supplyChainAPI,
        billType: key,
        componentName: key,
        type: null
      };

    case CA_DOCUMENT_TYPE_VALUES.BUSINESS_TRAVEL_TICKETS:
      return {
        mainAPI: businessTravelAPI,
        billType: key,
        componentName: key,
        type: null
      };

    case CA_DOCUMENT_TYPE_VALUES.WATER_BILLS:
      return {
        mainAPI: waterAPI,
        billType: key,
        componentName: key,
        type: null
      };
    default:
      return {
        mainAPI: undefined,
        billType: key ?? '',
        componentName: '',
        type: null
      };
  }
};

export default getPrerequisiteMasterData;
